"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KushkiService = void 0;
/**
 * Kushki Service file
 */
const Identifiers_1 = require("./../../lib/constant/Identifiers");
const KushkiError_1 = require("./../../lib/generic/KushkiError");
const ErrorEnum_1 = require("./../../lib/infrastructure/ErrorEnum");
const VisaBrandingResourceUrlEnum_1 = require("./../../lib/infrastructure/VisaBrandingResourceUrlEnum");
const inversify_1 = require("inversify");
require("reflect-metadata");
const Kushki_1 = require("./../../lib/Kushki");
/**
 * Implementation
 */
let KushkiService = class KushkiService {
    constructor(gateway) {
        this._gateway = gateway;
    }
    checkStatus(mid, isTest, regional) {
        return this._gateway.checkStatus(mid, isTest, regional);
    }
    requestBrandsByMerchant(mid, isTest, regional) {
        return this._gateway.requestBrandsByMerchant(mid, isTest, regional);
    }
    requestBrandsLogosByMerchant(mid, isTest, regional) {
        return this._gateway.requestBrandsLogosByMerchant(mid, isTest, regional);
    }
    initVisaBrandingAnimation(isTest, callback, body) {
        Promise.resolve().then(() => require("./../../lib/libs/VisaSensoryBranding/visa-sensory-branding")).then(() => {
            window.VisaSensoryBranding.init(body, isTest
                ? VisaBrandingResourceUrlEnum_1.VisaBrandingResourceUrlEnum.DEV
                : VisaBrandingResourceUrlEnum_1.VisaBrandingResourceUrlEnum.PROD);
            window.VisaSensoryBranding.show();
            window.addEventListener("message", e => {
                if (e.data === "visa-sensory-branding-end")
                    callback();
            });
        })
            .catch(() => Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E016), callback));
    }
    initMasterCardBrandingAnimation(callback, body) {
        Promise.resolve().then(() => require("./../../lib/libs/MCSensoryBranding/mastercard-sensory-branding")).then(({ MCSonic: mc_sonic }) => {
            const mc_component = new mc_sonic();
            const container = document.getElementById("mc-container");
            if (body.clearBackground)
                mc_component.clearBackground = body.clearBackground;
            if (body.type)
                mc_component.type = body.type;
            // @ts-ignore
            container.appendChild(mc_component);
            document.addEventListener("sonicCompletion", callback);
            mc_component.play();
        })
            .catch(() => Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E016), callback));
    }
};
KushkiService = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(Identifiers_1.IDENTIFIERS.KushkiGateway)),
    __metadata("design:paramtypes", [Object])
], KushkiService);
exports.KushkiService = KushkiService;
